import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SyncLog } from "../models/syncLog.model";
import { Page, PageParams } from "../paged.datasource";
import { Observable } from "rxjs";
import { ResourceService } from "@smartsoftware/reflex-core";
import { map } from "rxjs/operators";

/**
 * Uses the same backend service as SyncLog_Service.
 * Exists to override the page function for pagination.
 */
@Injectable()
export class SyncAdminLog_Service extends ResourceService<SyncLog> {
    protected servicePath = '/SyncLog';

    public ModelType = SyncLog;

    constructor(
        protected http: HttpClient
    ) {
        super(http);
    }

    page(pageParams: PageParams): Observable<Page<SyncLog>> {
        let params = new HttpParams().append('params', encodeURIComponent(btoa(JSON.stringify(pageParams))));
        return this.http.get<Page<SyncLog>>(`${this.serviceUrl}getLogsFromDate`, { params })
            .pipe(map((log) => {
                log.items = log.items.map(i => new SyncLog(i));
                return log;
            }));
    }

}